import React from "react";
import notify from "devextreme/ui/notify";
import "devextreme-react/text-area";
import { FileUploader, Button, SelectBox } from "devextreme-react";
//import { inserirOuAtualizar, criarVeiculosDs, criarTiposVeiculosDs } from "../../DataSources";
import apiAxios from "../api-axios";
import UserInfo from "../UserInfo";
import ambiente from "../ambiente";
import { getToken } from "../auth";


export default class EnviarArquivoProcessamento extends React.Component {
  constructor(props) {
    super(props);
    this.cancel = this.cancel.bind(this);
    this.headers = {
      "Authorization": `Bearer ${getToken()}`,
      "Access-Control-Allow-Origin": "*"      
    };

    this.setHeaders = this.setHeaders.bind(this);

    this.state = {
      formatos: ".ret",
      tipoArquivo: 4,
      uploadUrl: `${ambiente.URL_API}/receberarquivos/${UserInfo.getPrefeitura()}/4`
    };

    this.formElement = React.createRef();

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onArquivoSelecionado = this.onArquivoSelecionado.bind(this);

    this.tipoArquivo = [
      { value: ".ret", display: "RETORNO FEBRABAN", tipoArquivo: 4 },
      { value: ".ret", display: "RETORNO BOLETO", tipoArquivo: 3 },
      { value: ".txt", display: "PGDAS-D", tipoArquivo: 2 },
      { value: ".ret", display: "DAF607", tipoArquivo: 1 },
    ];
  }

  setHeaders(e) {
    console.log("send ", e);

  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <h3>ENVIAR ARQUIVO PARA PROCESSAMENTO (EM MANUTENÇÃO)</h3>
          <form
            id="form"
            ref={this.formElement}
            method="post"
            action=""
            encType="multipart/form-data"

          >
            <div style={{ marginLeft: "5px", marginBottom: "25px" }}>
              <SelectBox
                dataSource={this.tipoArquivo}
                valueExpr="tipoArquivo"
                displayExpr="display"
                placeholder="Todos"
                defaultValue={4}
                onValueChanged={this.onChange}
              />
            </div>
            <FileUploader
              name={"myFile"}
              selectButtonText="Selecione o(s) arquivo(s)"
              labelText="ou arraste os arquivos aqui"
              accept={"*"}
              multiple={true}
              uploadUrl={this.state.uploadUrl}
              uploadHeaders={this.headers}
              uploadMode={"useButtons"}
            />
          </form>
        </div>
      </React.Fragment>
    );
  }

  onArquivoSelecionado(e) {
    this.setState({ files: e.value });
  }

  onChange(e) {
    console.log("dados tipo arquivo", e);
    let formato = this.tipoArquivo.find((x) => x.tipoArquivo == e.value);
    const uploadUrl = `${ambiente.URL_API}/receberarquivos/${UserInfo.getPrefeitura()}/${e.value}`;
    this.setState({ tipoArquivo: e.value, formatos: formato.value, uploadUrl });
  }

  async onClick(e) {

    console.log(this.state);
    var bodyFormData = new FormData();
    bodyFormData.append("files", this.state.files);
    bodyFormData.append("tipoArquivo", this.state.tipoArquivo);
    bodyFormData.append("prefeituraId", UserInfo.getPrefeitura());

    apiAxios.post("/receberarquivos", bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
      console.log(response);
    });
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
